import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";

const styles = createUseStyles(theme => ({
  retroNoDataWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "48px 0px",
    maxWidth: "352px",
    "& h1": {
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      color: colors.lightBlack,
      marginBottom: "4px",
      marginTop: "16px"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: 0
    }
  },
  clearSearchButton: {
    marginRight: "0px !important",
    padding: "10px 18px",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "600",
    border: "1px solid" + colors.darkGrey,
    marginTop: "24px",
    color: colors.grey
  },
}));

export default styles;
